class DetailsModal extends HTMLElement {
	constructor() {
		super();
		this.detailsContainer = this.querySelector("details");
		this.summaryToggle = this.querySelector("summary");

		this.detailsContainer.addEventListener(
			"keyup",
			(event) => event.code === "Escape" && this.close()
		);
		this.summaryToggle.addEventListener(
			"click",
			this.onSummaryClick.bind(this)
		);

		this.querySelectorAll('button[type="button"]').forEach((e) => {
			e.addEventListener("click", (event) => {
        if (this.matches(".header__search")) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
        this.close();
      }, true);
		});

		this.summaryToggle.setAttribute("role", "button");
		this.summaryToggle.setAttribute("aria-expanded", "false");
	}

	isOpen() {
		return this.detailsContainer.hasAttribute("open");
	}

	onSummaryClick(event) {
		event.preventDefault();
        if (this.isClosing) return;
		event.target.closest("details").hasAttribute("open")
			? this.close()
			: this.open(event);
	}

	onBodyClick(event) {
		if (
			document
				.querySelector("header")
				.classList.contains("search-header--opened")
		) {
			return;
		}
		if (!this.contains(event.target)) this.close(false);
	}

	open(event) {
		this.onBodyClickEvent =
			this.onBodyClickEvent || this.onBodyClick.bind(this);
		event.target.closest("details").setAttribute("open", true);
		document.body.addEventListener("click", this.onBodyClickEvent);

		trapFocus(
			this.detailsContainer.querySelector('[tabindex="-1"]'),
			this.detailsContainer.querySelector('input:not([type="hidden"])')
		);
	}

  close(focusToggle = true) {
    if (this.isClosing || !this.isOpen()) return;
    const finish = () => {
      this.detailsContainer.removeAttribute("open");
      document.body.removeEventListener("click", this.onBodyClickEvent);
      document.body.classList.remove("overflow-hidden", "search-overflow-hidden");
      if (this.matches(".header__search")) {
        this.closest("header")?.classList.remove("search-header--opened");
      }
      this.isClosing = false;
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
    };
    const item = this.querySelector(".search-modal__item");
    if (!item || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      finish();
      return;
    }
    this.isClosing = true;
    const styles = getComputedStyle(item);
    const properties = styles.transitionProperty.split(",").map(value => value.trim());
    const durations = styles.transitionDuration.split(",");
    const opacityIndex = properties.indexOf("opacity");
    const durationValue = durations[(opacityIndex < 0 ? 0 : opacityIndex) % durations.length].trim();
    const duration = parseFloat(durationValue) * (durationValue.endsWith("ms") ? 1 : 1000);
    const animation = item.animate([{ opacity: styles.opacity }, { opacity: 0 }], {
      duration: Number.isFinite(duration) ? duration : 300,
      easing: "linear",
      fill: "forwards"
    });
    animation.finished.then(() => {
      finish();
      animation.cancel();
    }).catch(finish);
  }
}

customElements.define("details-modal", DetailsModal);
